import React from 'react';
import { renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';

export const list = () => {
  const rowClickedUrl = id => '';
  const loadNextUrl = '/customer/reports.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns, {
    rowHeight: 60,
  });
};

const renderAction = ({ rowData }) => {
  const id = rowData.id;
  const docType = rowData.type;

  switch (docType) {
    case 'PCO':
      return (
        <div>
          <a
            href={`/customer/reports/${id}/pdf`}
            target="_blank"
            className="ui basic button"
          >
            <i className="file pdf outline icon" />
            PDF
          </a>
        </div>
      );
    case 'AAST':
      return (
        <div>
          <a
            href={`/customer/reports/aast/${id}/pdf`}
            target="_blank"
            className="ui basic button"
          >
            <i className="file pdf outline icon" />
            PDF
          </a>
        </div>
      );
    default:
      return (
        <div>
          <a
            href={`/customer/reports/${id}/pdf`}
            target="_blank"
            className="ui basic button"
          >
            <i className="file pdf outline icon" />
            PDF
          </a>
        </div>
      );
  }
};

function renderColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 2}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="case"
      dataKey="case"
      width={(width / 16) * 6}
      label="Chantier"
    />,
    <Column key="site" dataKey="site" width={(width / 16) * 6} label="Site" />,
    <Column key="date" dataKey="date" width={(width / 16) * 2} label="Date" />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/customer/reports.js